<template>
  <b-carousel-list
    :arrow="true"
    :arrow-hover="false"
    v-model="item_pointer"
    :data="products"
    :items-to-show="this.device.isMobileOnly ? 1 : 5"
    :repeat="false"
  >
    <template #item="list">
      <div class="card" style="min-height: 440px; margin: 0 5px">
        <div class="card-content">
          <div style="position: relative">
            <span
              v-if="list.current_price && list.current_price.has_discount"
              title="Producto en descuento"
              class="badge is-top"
              ><b>
                <span v-if="list.current_price.discount_type == 'relative'"
                  >-{{ list.current_price.discount_amount | number }}%</span
                >
                <span v-if="list.current_price.discount_type == 'fixed'"
                  >-${{ list.current_price.discount_amount | number }}</span
                >

                OFF</b
              ></span
            >
            <a :href="list.link">
              <media-img :img="list.img" bgsize="contain" size="420x230" />
            </a>
          </div>

          <div v-if="list.rating" class="level is-mobile">
            <div
              class="level-item"
              v-for="(n, index) in list.rating.config.max_points"
              :key="index"
            >
              <img
                v-if="n <= list.rating.points"
                :src="list.rating.config.icon_on"
                width="22"
                height="22"
              />
              <img
                v-else
                :src="list.rating.config.icon_off"
                width="22"
                height="22"
              />
            </div>
            <div class="level-item is-size-6">
              ({{ list.rating.points | number }})
            </div>
          </div>

          <div class="product-title">
            <a :href="list.link">
              <h5 class="is-6 has-text-primary has-text-centered">
                {{ list.title }}
              </h5>
            </a>
          </div>
          <div class="product-stock has-text-centered">
            <div v-if="list.stock > 0" class="has-text-success">
              <i class="mdi mdi-check-circle-outline"></i> Disponible
            </div>
            <div v-else class="has-text-danger">
              <i class="mdi mdi-close-circle-outline"></i> Agotado
            </div>
          </div>
          <div class="product-prce">
            <h5 class="is-6 has-text-primary has-text-centered">
              <div class="level is-mobile has-background-light mt-3">
                <div class="level-item p-3 is-size-5 has-text-centered">
                  <div>
                    <div
                      v-if="
                        list.current_price && list.current_price.has_discount
                      "
                    >
                      <div>
                        <b>{{
                          list.current_price.discount_value | currency
                        }}</b>
                      </div>
                      <div class="is-size-6">
                        <del>{{ list.current_price.value | currency }}</del>
                      </div>
                    </div>
                    <div v-else>
                      <b>{{ list.price | currency }}</b>
                    </div>
                  </div>
                </div>
              </div>
            </h5>
          </div>
        </div>
      </div>
    </template>
  </b-carousel-list>
</template>

<script>
import AppMappers from "@/store/app-global-mappers";
export default {
  name: "ProductsCarousel",
  mixins: [AppMappers],
  props: ["data", "autoplay", "interval"],
  data() {
    return {
      products: [],
      item_pointer: 0,
      settings: {
        autoplay: false,
        interval: 2500,
      },
    };
  },
  created() {
    this.products = this.data;
    if (typeof this.autoplay !== "undefined") {
      this.settings.autoplay = this.autoplay;
    }
    if (typeof this.interval !== "undefined") {
      this.settings.interval = this.interval;
    }
  },
  mounted() {
    //console.log("Received data", this.products)
    if (this.settings.autoplay) {
      let interval = setInterval(this.increment, 2500);
    }
  },
  computed: {
    items_per_page() {
      if (this.device.isMobileOnly) {
        return 1;
      } else {
        return 5;
      }
    },
  },
  methods: {
    increment() {
      this.item_pointer++;
      // console.log(
      //   "Item Pointer vs Products Length",
      //   this.item_pointer,
      //   this.products.length
      // );
    },
  },
};
</script>

<style lang="css">
.carousel-list.has-shadow {
  box-shadow: none !important;
}
</style>